import { classNames, Heading06 } from '@uds/typography';
import { cx } from 'linaria';
import './badge.stylesheet_1h9r18g.css';
import { jsxs, jsx } from 'react/jsx-runtime';

let Kind;
(function (Kind) {
  Kind["PRIMARY"] = "PRIMARY";
  Kind["HIGHLIGHT"] = "HIGHLIGHT";
  Kind["WARNING"] = "WARNING";
  Kind["ALERT"] = "ALERT";
  Kind["NEUTRAL"] = "NEUTRAL";
  Kind["MUTED"] = "MUTED";
})(Kind || (Kind = {}));

const badgeWrapper = "b8lv12d";
const flushed = "f1jgljld";
const badge = "b1kjbh2x";
const badgeTag = "b1im6t4a";
const colors = {
  PRIMARY: "pi7709t",
  HIGHLIGHT: "h13te26t",
  WARNING: "wfo8huu",
  ALERT: "a1ts93wr",
  NEUTRAL: "nh9nguv",
  MUTED: "myd1t1i"
};
const getClassNames = _ref => {
  let {
    kind,
    flush
  } = _ref;
  return {
    badge: cx(badge, classNames.headingXxs, kind != null && colors[kind]),
    badgeWrapper: cx(badgeWrapper, flush && flushed),
    badgeTag
  };
};

const PureBadge = _ref => {
  let {
    children,
    tag,
    kind = Kind.PRIMARY,
    flush = false
  } = _ref;
  const classNames = getClassNames({
    kind,
    flush
  });
  return /*#__PURE__*/jsxs("div", {
    className: classNames.badgeWrapper,
    children: [/*#__PURE__*/jsx("div", {
      className: classNames.badge,
      children: children
    }), tag != null && /*#__PURE__*/jsx("span", {
      className: classNames.badgeTag,
      children: /*#__PURE__*/jsx(Heading06, {
        component: "span",
        children: tag
      })
    })]
  });
};
var PureBadge$1 = PureBadge;

export { PureBadge$1 as Badge, Kind, PureBadge$1 as default };
